export const environment = {   production: false,   environmentName: 'dev',   apiUrl: 'https://api.techbridge.edu.gh/aucdt-dev' };
